import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';

const EmailField = ({ 
  email, 
  inviteStatus, 
  updateEmail, 
  cancelInvite, 
  requireEmail, 
  invitedEmail, 
  emailError, 
  emailReadOnly,
  isLoadingEmail,
  isEditing,
  isCreating,
  onEnterPress
}) => {
  const [touched, setTouched] = useState(false);
  const [localEmail, setLocalEmail] = useState(email || invitedEmail || '');
  const [error, setError] = useState('');

  useEffect(() => {
    setLocalEmail(email || invitedEmail || '');
  }, [email, invitedEmail]);

  const handleBlur = () => {
    setTouched(true);
    if (requireEmail && !localEmail) {
      setError('Email is required');
    } else {
      setError('');
    }
  };

  const handleChange = (e) => {
    setLocalEmail(e.target.value);
    setError('');
    if (updateEmail) updateEmail(e.target.value);
  };
  
  const handleKeyDown = (e) => {
    // Check if Enter key was pressed
    if (e.key === 'Enter' && onEnterPress && !isDisabled) {
      e.preventDefault();
      onEnterPress();
    }
  };

  // Show loading state for email when editing an existing athlete
  const isLoading = isLoadingEmail && isEditing && !isCreating;

  // Email field is disabled if it's loading, read-only, or has a pending/accepted invitation
  const isDisabled = isLoading || emailReadOnly || inviteStatus === 'accepted' || inviteStatus === 'pending';
  
  // Determine which error to display - prioritize parent emailError over local error
  const displayError = emailError || (error && touched ? error : '');

  return (
    <div className={styles.emailContainer}>
      <div className={styles.label}>Email</div>
      <div className={styles.emailInputWrapper}>
        <input
          type="email"
          placeholder={
            isLoading
              ? "Loading..."
              : inviteStatus === 'accepted' 
                ? "Connected account email" 
                : emailReadOnly
                  ? "Your account email"
                  : requireEmail 
                    ? "Email for account invitation (required)" 
                    : "Email for account invitation"
          }
          value={isLoading ? "Loading..." : localEmail}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          className={`${styles.emailInput} ${(emailReadOnly || isLoading) ? styles.emailReadOnly : ''}`}
          disabled={isDisabled}
          required={!!requireEmail}
        />
        {displayError && (
          <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{displayError}</div>
        )}
        {inviteStatus === 'pending' && (
          <div className={styles.statusWrapper}>
            <div className={styles.statusPending}>
              Invitation pending
            </div>
            <button 
              type="button" 
              className={styles.cancelButton}
              onClick={() => cancelInvite && cancelInvite()}
            >
              Cancel
            </button>
          </div>
        )}
        {inviteStatus === 'accepted' && (
          <div className={styles.statusWrapper}>
            <div className={styles.statusAccepted}>
              Account connected
            </div>
            <button 
              type="button" 
              className={styles.cancelButton}
              onClick={() => cancelInvite && cancelInvite()}
            >
              Deassociate
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailField;